import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiEpBillingUpdate {
}
ApiEpBillingUpdate.update = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/update`,
    method: "POST",
});
//# sourceMappingURL=update.js.map